import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicResolve({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 8a5.75 5.75 0 018.022-5.284.75.75 0 10.593-1.378A7.202 7.202 0 008 .75 7.25 7.25 0 1015.25 8a.75.75 0 00-1.5 0 5.75 5.75 0 01-11.5 0zm12.08-3.47a.75.75 0 00-1.06-1.06L8.326 8.413 6.33 6.417a.75.75 0 00-1.06 1.06l2.526 2.527a.75.75 0 001.06 0L14.33 4.53z"
      />
    </svg>
  );
}

SvgBasicResolve.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicResolve.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicResolve svgRef={ref} {...props} />);
export default ForwardRef;
